import NotFound from "@views/NotFound"

export default NotFound
